// Static options buttons
export const likeButtonText = 'Adorei, tem desconto pra comprar?'
export const seeMoreButtonText = 'Hmm. Ainda tô na dúvida, tem mais dicas?'
export const restartButtonText = 'Quero fazer outra busca'
export const seeSelectWinesButtonText = 'Claro, manda aí'
export const showFinalThanksButtonText = 'Não precisa, obrigada!'

// Static bot messages
export const askForFeedbackMessageText = 'E aí, o que achou?'
export const positiveFeedbackResponseMessageText = 'Claro que sim! Deixe seu email aqui que vou enviar em seguida dois **cupons exclusivos** meus na Evino.'
export const afterResetTextMessage = 'Beleza, vamos lá do começo então.'
export const afterGetUserEmailMessageText = 'Ótimo! Já já estará na sua caixa. 😊'
export const offerSelectedWinesToMessageText = 'Posso te mostrar mais algumas listas legais de vinhos?'
export const finalThanksMessageText = 'Obrigado você! Espero que tenha gostado das dicas, e se precisar, você pode me encontrar neste site'
export const finalThanksMessageText2 = '[www.wine-locals.com](https://www.wine-locals.com)'
export const finalThanksMessageText3 = 'Até breve!'

// Dynamic bot messages
export const seeMoreFeedbackResponseMessageText = (isPlural) => {
  return `Tenho sim. Dá uma olhada ${isPlural ?  'nesses' : 'nesse'} aqui...`
}
export const messageBeforeShowResult = (isPlural) => {
  return `Legal. Acho que você vai gostar ${isPlural ? 'dessas dicas' : 'dessa dica'} aqui...`
}

// Advices
export const receiveTipsAndDealsByEmailAdviceText = 'Ao enviar aceito receber dicas e promoções por e-mail.'
